<template>
  <div v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">回答詳細・承否認</h3>
        </div>
      </div>
      <div class="card-body" v-if="form_detail.length">
        <el-table class="mb-5" :data="form_detail" style="width: 100%">
          <el-table-column prop="form_name" min-width="130" label="フォーム名">
            <template slot-scope="scope">
                <span v-if="scope.row.delete_flag === form_base_delete_flag.ACTIVE">
                    <router-link :to="{ name: 'edit-form', params: { form_id:  scope.row.form_id}}">
                        {{ scope.row.form_name }}
                    </router-link>
                 </span>
                <span v-else-if="scope.row.delete_flag === form_base_delete_flag.DELETE">
                    {{ scope.row.form_name }}
                </span>
              </template>
          </el-table-column>
          <el-table-column prop="form_url" min-width="130" label="フォームURL">
            <template slot-scope="scope">
                <span>
                <a target="_blank" :href="scope.row.user_url">
                   {{ scope.row.form_url }}
                </a>
                 </span>
              </template>
          </el-table-column>
<!--            phase 2-->
          <el-table-column prop="parent_form" min-width="130" label="親フォーム">
               <div v-if="formParent">
                    <span v-if="formParent.delete_flag === form_base_delete_flag.ACTIVE">
                        <router-link :to="{ name: 'edit-form', params: { form_id:  formParent.form_id }}">
                            {{ formParent.form_name }}
                        </router-link>
                    </span>
                   <span v-else-if="formParent.delete_flag === form_base_delete_flag.DELETE">
                       {{ formParent.form_name }}
                   </span>
               </div>
          </el-table-column>
          <el-table-column prop="current_authority" min-width="130" label="現担当権限">
              {{ currentRole }}
          </el-table-column>
<!--            phase 2-->
          <el-table-column prop="form_items_count" min-width="130" label="項目数">
          </el-table-column>
<!--            phase 2-->
          <el-table-column prop="child_form" min-width="130" label="子フォーム">
               <template slot-scope="scope">
                <span>
                <router-link :to="{ name: 'form-base-list', query: { form_child:  scope.row.form_id ? scope.row.form_id : '' }}">
                   {{ total_form_child }}
                </router-link>
                 </span>
              </template>
          </el-table-column>
<!--            phase 2-->
          <el-table-column prop="form_status" min-width="130" label="ステータス">
            <template slot-scope="scope">
              <span v-if="parseInt(scope.row.form_status) === constants.FORM_BASE_STATUS[0].value" class="statusDTD">{{constants.FORM_BASE_STATUS[0].label}}</span>
                <span v-else-if="parseInt(scope.row.form_status) === constants.FORM_BASE_STATUS[1].value" class="statusDKK">{{constants.FORM_BASE_STATUS[1].label}}</span>
            </template>
          </el-table-column>
        </el-table>
            <div class="row mb-8" v-if="answerDetail.info && answerDetail.info.approval_id &&(answerDetail.info.kaiso_flg === 1 || answerDetail.info.kaiso_flg === true) ">
              <div class="col-md-10 col-xl-5 d-flex align-items-center">
                <span>
                  階層状況: 
                </span>
                <ol class="breadcrumb"  v-if="answerDetail.info && answerDetail.info.tenant_breadcrumb.length > 0">
                    <li 
                        v-for="(item, index) in answerDetail.info.tenant_breadcrumb" 
                        :key="index"
                        class="breadcrumb-item"
                    >
                        <span 
                            v-if="item"
                            class="breadcrumb-link cursor-pointer" 
                            @click.prevent="handleBreadcrumbClick(item)"
                        >
                            {{ item.tenant_name }}
                        </span>
                        <span v-else>
                            テナント無し
                        </span>
                    </li>
                </ol>
                <p v-else>テナント無し</p>
              </div>
            </div>
<!--          phase 2-->
          <div class="row mb-3">
            <i @click="changeToggleTableStep()" v-if="toggleTableStep"
               class="fas fa-angle-down pr-2 text-size-27 angle-down"></i>
            <i @click="changeToggleTableStep()" v-else
               class="fas fa-angle-up pr-2 text-size-27 angle-up"></i>
              <h3 @click="changeToggleTableStep()" class="card-label">承認プロセスログ</h3>
          </div>
        <el-collapse-transition>
          <div v-show="toggleTableStep">
            <div class="row mb-3">
              <div class="col-md-2 col-6">
                <span>承認プロセス段階</span>
              </div>
              <div class="col-md-3 col-6">{{ currentStep.totalApprovalStep }} / ステップ{{ currentStep.currentApprovalStep }}</div>
            </div>
            <div id="data-table-list">
              <el-table class="mb-5 table-search" :data="currentStep.currentApprovalList"
                        style="width: 100%" @sort-change="sortTable">
                <el-table-column prop="step" min-width="130" class="column-table-2" label="ステップ" sortable="false">
                  <template slot-scope="scope">
                    <span>{{ scope.row.step }}</span>
                  </template>
                </el-table-column>
                  <el-table-column prop="approval_datetime" min-width="130" class="column-table-2" label="日付" sortable="false">
                      <template slot-scope="scope">
                          <span>{{ scope.row.approval_datetime }}</span>
                      </template>
                  </el-table-column>
                  <el-table-column prop="approval_status" min-width="150" class="column-table-2" label="アクション" sortable="false">
                      <template slot-scope="scope">
                              <span v-if="parseInt(scope.row.approval_status) === constants.STATUS_ANSWER.APPROVAL.KEY" class="statusDTD">{{constants.STATUS_ANSWER.APPROVAL.VALUE}}</span>
                              <span v-else-if="parseInt(scope.row.approval_status) === constants.STATUS_ANSWER.DENIAL.KEY" class="statusDKK">{{constants.STATUS_ANSWER.DENIAL.VALUE}}</span>
                              <span v-else-if="parseInt(scope.row.approval_status) === constants.STATUS_ANSWER.HOLD.KEY" class="statusDKK">{{constants.STATUS_ANSWER.HOLD.VALUE}}</span>
                              <span v-else-if="parseInt(scope.row.approval_status) === constants.STATUS_ANSWER.REVIEW.KEY" class="statusOD">{{constants.STATUS_ANSWER.REVIEW.VALUE}}</span>
                      </template>
                  </el-table-column>
                <el-table-column prop="role_name" min-width="130" class="column-table-2" label="担当ロール" sortable="false">
                  <template slot-scope="scope">
                    {{  scope.row.role_name }}
                  </template>
                </el-table-column>

                <el-table-column prop="mail" min-width="130" class="column-table-2" label="処理者" sortable="false">
                  <template slot-scope="scope">
                    {{  scope.row.mail  }}
                  </template>
                </el-table-column>

                <el-table-column prop="wariate_user_id" min-width="130" class="column-table-2" label="割り当て先 " sortable="false">
                  <template slot-scope="scope">
                    {{ scope.row.mail_wariate }}
                  </template>
                </el-table-column>

                <el-table-column prop="comment" min-width="130" class="column-table-2" label="コメント" sortable="false">
                  <template slot-scope="scope">
                    <span class="pre-comment" v-html="scope.row.comment"></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-collapse-transition>
<!--          phase 2-->
        <div v-for="(item,index) in item_groups.form" :key="index">
          <div v-if="item.display_group" class="d-flex">
              <i @click="item.display = !item.display" v-if="item.display"
                class="fas fa-angle-down pr-2 text-size-27 angle-down"></i>
              <i @click="item.display = !item.display " v-else
                 class="fas fa-angle-up pr-2 text-size-27 angle-up"></i>
              <h3 @click="item.display = !item.display" class="card-label" ref="he">{{item.group_name}}</h3>
              <div  class="group-reject-checkbox ml-6">
                <input 
                  type="checkbox" 
                  :checked="isGroupRejected(item)"
                  @change="handleGroupRejectChange($event, item)"
                  :disabled="disable_reject || answerDetail.user.delete_flag == 1"
                  :class="answerDetail.user.delete_flag == 1 ? 'disable-buttoon' : ''"
                />
              </div>
            </div>

            <el-collapse-transition>
              <div v-show="item.display">
                  <div v-for="(valueGroup,keyGroup) in item" :key="keyGroup">
                  <div v-for="(value,key) in valueGroup">
                      <div v-if="typeof value.child_group_name != 'undefined' && value.display_group" class="group-form"
                           :class="value.child_group_name != 'un_group'?'group-form-middle':''">
                          <div class="title-group-form" v-if="value.child_group_name != 'un_group'">
                            <span>{{value.child_group_name}}</span>
                            <div class="child-group-reject-checkbox ml-6">
                              <input 
                                type="checkbox" 
                                :checked="isChildGroupRejected(value)"
                                @change="handleChildGroupRejectChange($event, value)"
                                :disabled="disable_reject || answerDetail.user.delete_flag == 1"
                                :class="answerDetail.user.delete_flag == 1 ? 'disable-buttoon' : ''"
                              />
                            </div>
                          </div>
                          <div v-for="(field,k) in value.fields" :key="k" class="field-input-item">
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.TEXT && field.display">
                                  <el-row class="item-answer">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                          <label v-if="showLableRequired(field)" class="text-danger">*</label>
                                      </el-col>
                                      <el-col v-if="field.form_answer_value" :span="8" class="value" >
                                          <el-input :disabled="checkInputStatus(field)" class="bg-gray-item"
                                                    v-model="field.value"></el-input>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                      <el-col v-else-if="field.special_processing == type_input.HIDE_CUSTOMER" :span="8" class="value" >
                                          <el-input v-if="field.display_content" :disabled="checkInputStatus(field)" class="bg-gray-item"
                                                      v-model="field.display_content"></el-input>
                                          <el-input v-else :disabled="checkInputStatus(field)" class="bg-gray-item"
                                                      v-model="field.value"></el-input>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                      <el-col v-else-if="field.display_content" :span="8" class="value" >
                                          <el-input :disabled="checkInputStatus(field)" class="bg-gray-item"
                                                    v-model="field.display_content"></el-input>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                      
                                      <el-col v-else-if="field.special_processing == type_input.PASSWORD ||
                      field.special_processing == type_input.EMAIL" :span="8" class="value" >
                                          <el-input :disabled="checkInputStatus(field)" class="bg-gray-item" :type="field.special_processing == type_input.PASSWORD ? 'password' : 'text'"
                                                    placeholder=""
                                                    v-model="field.value"></el-input>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                      <el-col v-else :span="8" class="value" >
                                          <el-input :disabled="checkInputStatus(field)" class="bg-gray-item"
                                                    v-model="field.value" ></el-input>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                  </el-row>
                                  <el-row
                                      v-if="field.childFields.length > 0"
                                      v-for="(v,i) in field.childFields" :key="i"
                                      class="item-answer mt-4">
                                      <el-col :span="5" class="label_name">
                                      </el-col>
                                      <el-col  :span="8" class="value" >
                                          <el-input v-model="v.value" :disabled="checkInputStatus(field)" class="bg-gray-item"></el-input>
                                          <div v-if="errorField['field_child_'+field.item_id+'_value_'+i]" class="error-message">{{ errorField['field_child_'+field.item_id+'_value_'+i][0] }}</div>
                                      </el-col>
                                  </el-row>

                              </div>
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.TEXT_MULTIPLE_LINE && field.display">
                                  <el-row class="item-answer">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                          <label v-if="showLableRequired(field)" class="text-danger">*</label>
                                      </el-col>
                                      <el-col :span="8" class="value" >
                                          <el-input :disabled="checkInputStatus(field)" type="textarea" class="bg-gray-item" rows="3" v-model="field.value"></el-input>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                  </el-row>
                                  <el-row
                                      v-if="field.childFields.length > 0"
                                      v-for="(v,i) in field.childFields" :key="i"
                                      class="item-answer mt-4">
                                      <el-col :span="5" class="label_name">
                                      </el-col>
                                      <el-col  :span="8" class="value" >
                                          <el-input v-model="v.value" type="textarea" :disabled="checkInputStatus(field)" class="bg-gray-item"></el-input>
                                          <div v-if="errorField['field_child_'+field.item_id+'_value_'+i]" class="error-message">{{ errorField['field_child_'+field.item_id+'_value_'+i][0] }}</div>
                                      </el-col>
                                  </el-row>
                              </div>
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.SELECTION && field.display">
                                  <el-row class="item-answer">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                          <label v-if="showLableRequired(field)" class="text-danger">*</label>
                                      </el-col>
                                      <el-col :span="8" class="value" >
                                          <el-select
                                              :disabled="checkInputStatus(field)"
                                              v-if="field.selections.split(',').length > 0" style="width: 100%" class="w--10 bg-gray-item"
                                              placeholder="" v-model=field.value>
                                              <el-option
                                                  v-for="(valueItem, index) in field.selections.split(',')"
                                                  :key="index"
                                                  :label="valueItem"
                                                  :value="typeof field.value === 'number' ? index : String(index)">
                                              </el-option>
                                          </el-select>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                  </el-row>

                                  <el-row
                                      v-if="field.childFields.length > 0"
                                      v-for="(v,i) in field.childFields" :key="i"
                                      class="item-answer mt-4">
                                      <el-col :span="5" class="label_name">
                                      </el-col>
                                      <el-col  :span="8" class="value" >
                                          <el-select
                                              :disabled="checkInputStatus(field)"
                                              v-if="field.selections.split(',').length > 0" style="width: 100%" class="w--10 bg-gray-item"
                                              placeholder="" v-model="v.value">
                                              <el-option
                                                  v-for="(valueItem, index) in field.selections.split(',')"
                                                  :key="index"
                                                  :label="valueItem"
                                                  :value="typeof v.value === 'number' ? index : String(index)">
                                              </el-option>
                                          </el-select>
                                          <div v-if="errorField['field_child_'+field.item_id+'_value_'+i]" class="error-message">{{ errorField['field_child_'+field.item_id+'_value_'+i][0] }}</div>
                                      </el-col>
                                  </el-row>
                              </div>
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.SELECTION_MULTIPLE && field.display">
                                  <el-row class="item-answer">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                          <label v-if="showLableRequired(field)" class="text-danger">*</label>
                                      </el-col>
                                      <el-col :span="8" class="value" >
                                          <el-select
                                              :disabled="checkInputStatus(field)"
                                              multiple
                                              v-if="field.selections.split(',').length > 0"
                                              style="width: 100%" class="w--10 bg-gray-item"
                                              placeholder="" v-model="field.value">
                                              <el-option
                                                  v-for="(valueItem, index) in field.selections.split(',')"
                                                  :key="index"
                                                  :label="valueItem"
                                                  :value="index">
                                              </el-option>
                                          </el-select>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                  </el-row>

                                  <el-row
                                      v-if="field.childFields.length > 0"
                                      v-for="(v,i) in field.childFields" :key="i"
                                      class="item-answer mt-4">
                                      <el-col :span="5" class="label_name">
                                      </el-col>
                                      <el-col  :span="8" class="value" >
                                          <el-select
                                              multiple
                                              :disabled="checkInputStatus(field)"
                                              v-if="field.selections.split(',').length > 0" style="width: 100%" class="w--10 bg-gray-item"
                                              placeholder="" v-model="v.value">
                                              <el-option
                                                  v-for="(valueItem, index) in field.selections.split(',')"
                                                  :key="index"
                                                  :label="valueItem"
                                                  :value="index">
                                              </el-option>
                                          </el-select>
                                          <div v-if="errorField['field_child_'+field.item_id+'_value_'+i]" class="error-message">{{ errorField['field_child_'+field.item_id+'_value_'+i][0] }}</div>
                                      </el-col>
                                  </el-row>

                              </div>
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.FILE && field.display">
                                  <el-row class="item-answer">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                          <label v-if="showLableRequired(field)" class="text-danger">*</label>
                                      </el-col>
                                      <el-col :span="18" class="value">
                                          <div class="form-item item-upload">
                                            <div>
                                              <input :disabled="checkInputStatus(field)" style="display: none"
                                                 :id="'file-upload-'+index+'-'+k+'-'+field.item_id" type="file"
                                                 @change="uploadFile($event,field)">
                                              <label :for="'file-upload-'+index+'-'+k+'-'+field.item_id"
                                                    class="file-drag file-upload-btn btn btn-primary button-upload-file"
                                                    :class="checkInputStatus(field) || loading ? 'disabled-upload-image' : ''">
                                                  ファイル選択
                                              </label>
                                              <div v-if="field.value" class="d-flex align-items-center">
                                                  <a :href="field.value.url_download_file" class="file-anchor">
                                                      {{field.value.file_name_before }}
                                                  </a>
                                                  <i v-if="field.item_role === 3 && field.value.file_name_before" class="el-icon-circle-close el-icon--right ml-2 cursor-pointer" @click="confirmRemoveFile(field)"></i>
                                              </div>
                                            </div>

                                            <a href="javascript:void(0)" class="view-version"
                                                @click.prevent="updateVersion(field.file_id,field.item_id,field.label_name)">
                                                {{ $t("VIEW_VERSION_FILE") }}
                                            </a>
                                          </div>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">
                                              {{ errorField['field_' + field.item_id][0] }} 
                                          </div>
                                      </el-col>
                                  </el-row>

                                  <el-row
                                      v-if="field.childFields.length > 0"
                                      v-for="(v,i) in field.childFields" :key="i"
                                      class="item-answer mt-4">
                                      <el-col :span="5" class="label_name">
                                      </el-col>
                                      <el-col  :span="18" class="value" >
                                        <div class="form-item item-upload">
                                          <div>
                                            <input :disabled="checkInputStatus(v)" style="display: none" :id="'file-upload-child-'+index+'-'+k+'-'+field.item_id+'-'+i" type="file" @change="uploadFile($event,v)">
                                            <label :for="'file-upload-child-'+index+'-'+k+'-'+field.item_id+'-'+i" class="file-drag file-upload-btn btn btn-primary button-upload-file" :class="checkInputStatus(v) ? 'disabled-upload-image' : ''">
                                                ファイル選択
                                            </label>
                                            <a v-if="v.value || v.field_value" :href="(v.value && v.value.url_download_file) || (v.field_value && v.field_value.url_download_file)" class="file-anchor">
                                                  {{(v.value && v.value.file_name_before) || (v.field_value && v.field_value.file_name_before)}} 
                                              </a>
                                          </div>

                                          <a href="javascript:void(0)" class="view-version" @click.prevent="updateVersion(v.value.file_id,v.item_id,v.label_name)">
                                                  版確認
                                              </a>
                                        </div>
                                        <div v-if="errorField['field_child_'+field.item_id+'_value_'+i]" class="error-message">{{ errorField['field_child_'+field.item_id+'_value_'+i][0] }}</div>
                                      </el-col>
                                  </el-row>
                              </div>
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.LABEL && field.display">
                                  <el-row class="item-answer">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                          <label v-if="showLableRequired(field)" class="text-danger">*</label>
                                      </el-col>
                                      <el-col :span="18" class="value" >
                                          <div class="label-field-preview"  v-html="field.display_content"></div>
                                      </el-col>
                                  </el-row>

                                  <el-row
                                      v-if="field.childFields.length > 0"
                                      v-for="(v,i) in field.childFields" :key="i"
                                      class="item-answer mt-4">
                                      <el-col :span="5" class="label_name"></el-col>
                                      <el-col :span="18" class="value" >
                                          <div class="label-field-preview"  v-html="field.display_content"></div>
                                      </el-col>
                                  </el-row>

                              </div>
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.DATETIME && field.display">
                                  <el-row class="item-answer">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                          <label v-if="showLableRequired(field)" class="text-danger">*</label>
                                      </el-col>
                                      <el-col :span="8" class="value" >
                                          <el-date-picker :disabled="checkInputStatus(field)" type="datetime" v-model="field.value" class="bg-gray-item" rows="3" ></el-date-picker>
                                          <div v-if="errorField['field_'+field.item_id]" class="error-message">{{errorField['field_'+field.item_id][0]}}</div>
                                      </el-col>
                                  </el-row>
                                  <el-row
                                      v-if="field.childFields.length > 0"
                                      v-for="(v,i) in field.childFields" :key="i"
                                      class="item-answer mt-4">
                                      <el-col :span="5" class="label_name">
                                      </el-col>
                                      <el-col  :span="8" class="value" >
                                          <el-date-picker type="datetime" v-model="v.value" :disabled="checkInputStatus(field)" class="bg-gray-item"></el-date-picker>
                                          <div v-if="errorField['field_child_'+field.item_id+'_value_'+i]" class="error-message">{{ errorField['field_child_'+field.item_id+'_value_'+i][0] }}</div>
                                      </el-col>
                                  </el-row>

                              </div>
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.FILE_DOWNLOAD && field.display">
                                  <el-row class="item-answer mt-4">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                      </el-col>
                                      <el-col :span="8" class="value" >
                                          <a :href="field.url_download_file">{{getFileName(field.item_file_path) }}</a>
                                      </el-col>
                                  </el-row>

                                  <el-row
                                      v-if="field.childFields.length > 0"
                                      v-for="(v,i) in field.childFields" :key="i"
                                      class="item-answer mt-4">
                                      <el-col :span="5" class="label_name">{{field.label_name}}
                                      </el-col>
                                      <el-col :span="8" class="value" >
                                          <a :href="field.url_download_file">{{getFileName(field.item_file_path) }}</a>
                                      </el-col>
                                  </el-row>

                              </div>
                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.CALCULATION">
                                <el-row class="item-answer">
                                  <el-col :span="5" class="label_name">{{field.label_name}}
                                  </el-col>
                                  <el-col :span="8" class="value" >
                                    <el-input disabled class="bg-gray-item" rows="3" v-model="field.value"></el-input>
<!--                                    <div>{{field.previewCalculation}}</div>-->
                                  </el-col>
                                </el-row>
                              </div>

                              <div class="m-0 mb-4 transition-box" v-if="field.input_method == fieldType.TABLE">
                                <el-row class="item-answer">
                                  <InputTablesView  
                                    :field="field" 
                                    :disabled="checkInputStatus(field)" 
                                    :answer_id="queryParam.answer_id" 
                                    :sendListVersion="sendListVersion" 
                                    :checkReject="true" 
                                    :errors="errors['field_' + field.item_id]"
                                    :answerDetail="answerDetail.user"
                                    :disable_reject="disable_reject"
									                  :is_rejected="fields_reject.findIndex(id => id.toString() === field.item_id.toString()) > -1"
									                  v-on:change_reject_table="changeFieldsReject"
                                    v-on:table-value-changed="handleTableValueChange"
                                    />
                                </el-row>
                              </div>

                              <div class="field-reject" v-if="field.item_id 
                                && [type_input.PASSWORD, type_input.EMAIL].indexOf(field.special_processing) < 0
                                && !(field.special_processing === 4 && answerDetail.info && answerDetail.info.approval_id && (answerDetail.info.kaiso_flg === 1 || answerDetail.info.kaiso_flg === true))
                                && [fieldType.LABEL, fieldType.CALCULATION, fieldType.FILE_DOWNLOAD].indexOf(field.input_method) < 0 && field.item_role !== 3
                                ">
                                <input 
                                  type="checkbox" 
                                  name="field_reject[]" 
                                  :value="field.item_id" 
                                  v-model="fields_reject" 
                                  :disabled="disable_reject || answerDetail.user.delete_flag == 1"
                                  :class="answerDetail.user.delete_flag == 1 ? 'disable-buttoon' : ''"
                                  @change="fieldRejectChange"
                                /> 
                              </div>
                          </div>
                      </div>
                  </div>
           </div>
           </div>
           </el-collapse-transition>
        </div>
        <el-row>
          <el-col :span="5" class="label_name"
            ><h3 class="card-label" ref="he">コメント</h3></el-col
          >
          <el-col :span="18" class="value textarea-form"
            ><el-input
              v-model="comment"
              :rows="6"
              prop="comment"
              type="textarea"
              class="textarea"
            ></el-input
          ></el-col>
        </el-row>
        <div class="card mt-5"></div>
        <el-row class="text-center button-update-status" >
<!--            comment out-->
<!--            <el-button :disabled="answerDetail.disableButton" :class="answerDetail.disableButton ? 'disable-buttoon' : ''"
                type="primary"
                @click.prevent="handleProcess(constants.HANDLE_PROCESS.UPDATE_VALUE.KEY)"
                class="btn-submit"
            >{{ constants.HANDLE_PROCESS.UPDATE_VALUE.VALUE }}</el-button
            >
          <el-button :disabled="answerDetail.disableButton" :class="answerDetail.disableButton ? 'disable-buttoon' : ''"
            type="primary"
            @click.prevent="handleProcess(constants.HANDLE_PROCESS.CONFIRM.KEY)"
            class="btn-submit"
            >{{ constants.HANDLE_PROCESS.CONFIRM.VALUE }}</el-button
          >
          <el-button :disabled="answerDetail.disableButton" :class="answerDetail.disableButton ? 'disable-buttoon' : ''"
            type="primary"
            @click.prevent="handleProcess(constants.HANDLE_PROCESS.REJECT.KEY)"
            class="btn-submit"
            >{{ constants.HANDLE_PROCESS.REJECT.VALUE }}</el-button
          >
          <el-button :disabled="answerDetail.disableButton" :class="answerDetail.disableButton ? 'disable-buttoon' : ''"
            type="primary"
            @click.prevent="handleProcess(constants.HANDLE_PROCESS.SAVE.KEY)"
            class="btn-submit"
            >{{ constants.HANDLE_PROCESS.SAVE.VALUE }}</el-button
          >
          <el-button :disabled="answerDetail.disableButton" :class="answerDetail.disableButton ? 'disable-buttoon' : ''" type="primary" @click.prevent="openPopupChangeRole()" class="btn-submit">{{constants.HANDLE_PROCESS.CHANGE_OF_CHRAGE.VALUE }}</el-button>-->

            <el-button :disabled="answerDetail.user.delete_flag == 1" :class="answerDetail.user.delete_flag == 1 ? 'disable-buttoon' : ''"  type="primary" @click.prevent="handleProcess(constants.HANDLE_PROCESS.UPDATE_VALUE.KEY)" class="btn-submit">{{ constants.HANDLE_PROCESS.UPDATE_VALUE.VALUE }}</el-button>
            <el-button :disabled="answerDetail.user.delete_flag == 1" :class="answerDetail.user.delete_flag == 1 ? 'disable-buttoon' : ''"  type="primary" @click.prevent="handleProcess(constants.HANDLE_PROCESS.CONFIRM.KEY)" class="btn-submit">{{ constants.HANDLE_PROCESS.CONFIRM.VALUE }}</el-button>
            <el-button :disabled="answerDetail.user.delete_flag == 1" :class="answerDetail.user.delete_flag == 1 ? 'disable-buttoon' : ''"  type="primary" @click.prevent="handleProcess(constants.HANDLE_PROCESS.REJECT.KEY)" class="btn-submit">{{ constants.HANDLE_PROCESS.REJECT.VALUE }}</el-button>
            <el-button :disabled="answerDetail.user.delete_flag == 1" :class="answerDetail.user.delete_flag == 1 ? 'disable-buttoon' : ''"  type="primary" @click.prevent="handleProcess(constants.HANDLE_PROCESS.SAVE.KEY)" class="btn-submit">{{ constants.HANDLE_PROCESS.SAVE.VALUE }}</el-button>
            <el-button :disabled="answerDetail.user.delete_flag == 1" :class="answerDetail.user.delete_flag == 1 ? 'disable-buttoon' : ''"  type="primary" @click.prevent="openPopupChangeRole()" class="btn-submit">{{constants.HANDLE_PROCESS.CHANGE_OF_CHRAGE.VALUE }}</el-button>
            <el-button v-if="answerDetail.user.delete_flag == 0" type="primary" @click.prevent="openPopupDetele(1)" class="btn-submit">{{constants.HANDLE_PROCESS.SOFT_DELETE.VALUE }}</el-button>
            <el-button  v-if="answerDetail.user.delete_flag == 1" type="primary" @click.prevent="openPopupDetele(3)" class="btn-submit">{{constants.HANDLE_PROCESS.RESTORE.VALUE }}</el-button>
            <el-button :disabled="answerDetail.user.delete_flag == 0" :class="answerDetail.user.delete_flag == 0 ? 'disable-buttoon' : ''" type="primary" @click.prevent="openPopupDetele(2)" class="btn-submit">{{constants.HANDLE_PROCESS.FOCE_DELETE.VALUE }}</el-button>
        </el-row>
        <el-row class="text-center mt-3" v-if="shouldShowSendChildTenantLoginMail">
          <el-checkbox v-model="sendChildTenantLoginMail">回答者にログインURL、ログインIDをメールで通知する</el-checkbox> 
        </el-row>
      </div>
    </div>
    <b-modal id="confirm" hide-header hide-footer centered>
      <div>
        <div class="modal-header text-center">
          <h3 style="width: 100%">確認</h3>
        </div>
        <div class="modal-body">{{ title }}</div>
        <div class="modal-footer text-center" style="justify-content: center">
          <b-button class="btn-primary" @click="closePopup('confirm')">
            {{ $t("NO") }}
          </b-button>
          <b-button class="btn-primary" :disabled="disable_confirm" @click.prevent="handleCheck(key)">
            {{ $t("YES") }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="error-update" hide-header hide-footer centered>
      <div>
        <div class="modal-header text-center">
        </div>
        <div class="modal-body">{{ title }}</div>
        <div class="modal-footer text-center" style="justify-content: center">
          <b-button class="btn-primary" @click="closePopup('errorUpdate')">
            {{ $t("close_popup_error") }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal id="error-required" hide-header hide-footer centered>
      <div>
        <div class="modal-header text-center">
        </div>
        <div class="modal-body">項目に不備があります。ご確認ください。</div>
        <div class="modal-footer text-center" style="justify-content: center">
          <b-button class="btn-primary" @click="closePopup('errorRequired')">
            {{ $t("close_popup_error") }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal id="answer-conflict-proceed" hide-header hide-footer centered>
      <div>
        <div class="modal-header text-center">
          <h3 style="width: 100%">確認</h3>
        </div>
        <div class="text-center">
          保存済みのデータと異なる内容が入力されています。 </br>
          <span>「はい」を選択すると、現在の入力内容で保存済みデータを上書きします。</br>続行しますか？</span>
        </div>
        <div class="modal-footer text-center" style="justify-content: center">
          <b-button class="btn-primary" @click.prevent="answerConflictProceedNo">
            {{ $t("NO") }}
          </b-button>
          <b-button
            class="btn-outline-primary mr-2"
            :disabled="disable_conflict_proceed"
            @click.prevent="answerConflictProceedYes"
          >
          {{ $t("YES") }}
          </b-button>
        </div>
      </div>
    </b-modal>

      <b-modal id="delete_form_answer" hide-header hide-footer centered>
          <div>
              <div class="modal-header text-center">
                  <h3 v-if="checkMethodDetele == 3"  style="width: 100%">確認</h3>
                  <h3 v-else style="width: 100%">確認</h3>
              </div>
              <div v-if="checkMethodDetele == 3" class="modal-body text-center">{{ this.queryParam.answer_id + 'をゴミ箱から戻しますか？' }} </div>
              <div v-else class="modal-body text-center">{{ this.queryParam.answer_id + 'を' + (this.checkMethodDetele == 1 ? '論理削除 ' : '物理削除') + 'しますか？' }}
              </div>
              <div class="modal-footer text-center" style="justify-content: center">
                  <b-button class="btn-primary" @click="closePopup('delete_form_answer')">
                      {{ $t("NO") }}
                  </b-button>
                  <b-button class="btn-primary" @click.prevent="deteleFormAnswer">
                      {{ $t("YES") }}
                  </b-button>
              </div>
          </div>
      </b-modal>

    <!-- modal confirm version file -->
    <b-modal id="answer_file" size="lg" centered :title="label_name">
      <div>
        <el-table class="mb-5" :data="listVersion" style="width: 100%">
          <el-table-column prop="file_edition" label="版" width="40">
          </el-table-column>
          <el-table-column prop="update_datetime" label="日付">
          </el-table-column>
          <el-table-column prop="file_name_after" label="ファイル名変更後">
            <template slot-scope="scope">
              <a :href="scope.row.url_download_file">
                {{scope.row.file_name_after}}
              </a>
            </template>
          </el-table-column>
            <el-table-column prop="file_name_before" label="ファイル名変更前">
                <template slot-scope="scope">
                    <a :href="scope.row.url_download_file">
                        {{scope.row.file_name_before}}
                    </a>
                </template>
            </el-table-column>
        </el-table>
      </div>
      <template #modal-footer>
        <div class="text-center" style="width: 100%">
          <b-button
              variant="primary"
              size="sm"
              @click="closePopup('answer_file')"
          >
            {{ $t("close_popup_error") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal id="change-role" hide-header hide-footer centered>
      <div>
        <div class="modal-header text-center">
          <h3 style="width: 100%">確認</h3>
        </div>
        <div class="modal-body">
          <p>{{ $t("CHANGE_ROLE", {answer_id: answer_id}) }}</p>
          <div>
            <el-select style="width: 100%" v-model="change_role" placeholder="Select">
              <el-option
                  v-for="item in allRole"
                  :key="item.role_id"
                  :label="item.role_name"
                  :value="item.role_id">
              </el-option>
            </el-select>
            <div v-if="this.errorMessageChangeRole.hasOwnProperty('role') > 0 && this.errorMessageChangeRole.role.length > 0" class="error-message">
              {{this.errorMessageChangeRole.role[0]}}
            </div>
          </div>
        </div>
        <div class="modal-footer text-center" style="justify-content: center">
          <b-button class="btn-primary" @click="closePopup('change-role')">
            {{ $t("NO") }}
          </b-button>
          <b-button class="btn-primary" @click.prevent="handleCheck(constants.HANDLE_PROCESS.CHANGE_OF_CHRAGE.KEY)">
            {{ $t("YES") }}
          </b-button>
        </div>
      </div>
    </b-modal>
      <my-dialog v-on:closeDialog="not_permisson_popup=false" v-on:submit="not_permisson_popup=false;$router.push({name: 'permission-denied'});" v-bind:dialog="not_permisson_popup"
                 :closeOnClickModal="false" width="28%" v-bind:btnOk="$t('DIALOG.BTN_OKIE_PERMISSON_DENIED')" :showCancelButton="false">
          <template slot="header">
              <div class="textwidget text-center">
                  {{ $t('DIALOG.TITLE_PERMISSON_DENIED') }}
              </div>
          </template>
      </my-dialog>
      
      <!-- Modal for breadcrumb permission error -->
      <my-dialog v-on:closeDialog="breadcrumbPermissionError=false" v-on:submit="breadcrumbPermissionError=false" v-bind:dialog="breadcrumbPermissionError"
         :closeOnClickModal="false" width="28%" btnOk="閉じる" :showCancelButton="false">
          <template slot="content">
              <div class="textwidget text-center">
                アカウントの権限がありませんですので、管理者にご連絡してください。
              </div>
          </template>
      </my-dialog>
      
    <b-modal id="error-reject" hide-header hide-footer centered>
      <div>
        <div class="modal-header text-center">
        </div>
        <div class="modal-body"> {{ modal_error_msg|| '項目に不備があります。ご確認ください。'}}</div>
        <div class="modal-footer text-center" style="justify-content: center">
          <b-button class="btn-primary" @click="$bvModal.hide('error-reject')">
            {{ $t("close_popup_error") }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- File removal confirmation modal -->
    <b-modal
        id="confirmRemoveFileModal"
        title="ファイル削除確認" 
        hide-header 
        hide-footer
        size="m"
        centered
        ok-variant="danger"
    >
        <div class="text-center header-modal">
            <h4>確認</h4>
        </div>
        <div class="text-center">
            <p class="mb-3">この添付ファイルを削除してもよろしいですか？</p>
        </div>
        <div class="modal-footer text-center" style="justify-content: center ;padding:15px 0px 0px 0px;">
            <b-button class="btn-primary" @click="cancelRemoveFile">
                {{ $t("NO") }}
            </b-button>
            <b-button class="btn-primary" @click="removeFile">
                {{ $t("YES") }}
            </b-button>
        </div>
    </b-modal>
  </div>
</template>
<script>
import * as constants from "@/core/config/constant";
import {
  ANSWER_HANDLE_STATUS,
  CHANGE_ROLE,
  CHANGE_TOGGLE_TABLE_STEP,
  CHECK_ANSWER_DATA_CONFLICT,
  GET_ANSWER_DETAIL,
  GET_LIST_VERSION,
  REMOVE_ERROR_CHANGE_ROLE,
  RESTORE,
  STORE_FOCE_DELETE,
  STORE_SOFT_DELETE,
  UPDATE_ANSWER_VALUE
} from "@/core/services/store/answerDetail.module";
import { mapActions, mapGetters } from "vuex";

import {
  BUILD_URL_DOWNLOAD_FILE,
  BYTES_TO_SIZE,
  UPLOAD_FILE_USER,
} from "@/core/services/store/file.module";
import { FORM_ITEM_DELETE_UPLOAD_FILE_ANSWER_DETAIL } from "@/core/services/store/formStore";
import {
  GET_ALL_ROLE,
} from "@/core/services/store/role.module";
import InputTablesView from "@/view/components/inputs/InputTablesView";

export default {
  components:{InputTablesView},
  data() {
    return {
      comment: "",
      constants: constants,
      loading: false,
      title: "",
      data: [],
      key: "",
      form_detail: [],
      value_form_detail: {},
      item_groups: {},
      listVersion: [],
      listAccount:[],
      errors: [],
      label_name:'',
      fieldType:constants.FIELDS,
      value_before: '',
      answer_id: '',
      type_input: constants.CHECK_TYPE_INPUT,
      activeNames: ['1'],
        formParent:{},
        total_form_child:0,
        currentRole:'',
        currentStep:[],
      change_role: '',
      tessst: [1,2,5],
      form_base_delete_flag: constants.FORM_BASE_DELETE_FLAG,
      errorField:{},
      checkMethodDetele: "",
      not_permisson_popup: false,
      disable_confirm: false,
      fields_reject:[],
	    tables_reject: {},
      disable_reject: false,
      modal_error_msg: '',
      fileToRemove: null,
      breadcrumbPermissionError: false,
      pendingConflictKey: null,
      pendingConflictAnswerValue: null,
      pendingConflictAnswerId: null,
      pendingConflictEmail: null,
      pendingConflictErrors: [],
      disable_conflict_proceed: false,
    };
  },
  computed: {
    ...mapGetters(["answerDetail","toggleStatus","allRole","errorMessageChangeRole","toggleTableStep","currentUser"]),
    queryParam() {
      return this.$route.params;
    },
    sendChildTenantLoginMail: {
      get() {
        if (!this.answerDetail.info) return false;
        const value = this.answerDetail.user.send_child_tenant_login_mail;
        if (value === null || value === undefined) {
          return true;
        }
        return value === 1 || value === true;
      },
      set(value) {
        if (this.answerDetail.info) {
          this.answerDetail.user.send_child_tenant_login_mail = value ? 1 : 0;
        }
      }
    },
    isApprovalKaisoZero() {
      if (!this.answerDetail.info || !this.answerDetail.info.approval_id || this.answerDetail.info.approval_id === ' ') {
        return false;
      }
      // Check if approval_kaiso exists in answerDetail.info.approval
      if (this.answerDetail.info.approval && this.answerDetail.info.approval.approval_kaiso !== undefined) {
        return this.answerDetail.info.approval.approval_kaiso === 0;
      }
      // If not found, return false (don't disable)
      return false;
    },
    shouldShowSendChildTenantLoginMail() {
      if (!this.answerDetail.info) return false;
      const hasKaisoFlg = this.answerDetail.info.kaiso_flg === 1 || this.answerDetail.info.kaiso_flg === true;
      const hasApprovalId = this.answerDetail.info.approval_id && this.answerDetail.info.approval_id !== ' ';
      const isNotKaisoZero = !this.isApprovalKaisoZero;
      return hasKaisoFlg && hasApprovalId && isNotKaisoZero;
    }
  },
  watch: {
    async queryParam() {
      this.loading = true;
      await this.getAnswerDetail(
        {
          answer_id: this.queryParam.answer_id,
          form_id: this.queryParam.form_id
        }
      );
      this.loading = false;
    },
    'item_groups.form': {
      handler:function (val, oldVal){
        let objectItem = {};
        let calculationFields = [];
        let listField = [];

        let form = this.item_groups.form;
        this.value_form_detail = this.item_groups.value;
        for (let i = 0;i < form.length;i++){
          let groups = form[i].groups;
          for (let j = 0;j < groups.length;j++){
            let fields = groups[j].fields;
            for (let k = 0;k < fields.length;k++){
              listField.push(fields[k]);
              if (fields[k].input_method === this.fieldType.CALCULATION){
                calculationFields.push(fields[k]);
              }
              
              // Nếu field.value là null thì lấy từ value_form_detail
              if (fields[k].value === null && this.value_form_detail[fields[k].item_id]) {
                fields[k].value = this.value_form_detail[fields[k].item_id];
              }
              
              if (fields[k].value == parseInt(fields[k].value)){
                objectItem['item_'+fields[k].item_id] = parseInt(fields[k].value);
              }
              if (fields[k].value == parseFloat(fields[k].value)){
                objectItem['item_'+fields[k].item_id] = parseFloat(fields[k].value);

              }

            }
          }
        }
        if (calculationFields.length > 0){
          for (let i = 0; i < calculationFields.length; i++){
            let calculation = [];
            let previewCalculation = [];
            for (let j = 0;j < calculationFields[i].calculation_decode.length;j++){
              let currentObject = calculationFields[i].calculation_decode[j];
              switch (currentObject.type){
                case this.constants.CALCULATION_TYPE.ITEM:
                  // objectItem['item_'+currentObject.id] = 0;
                  calculation.push('objectItem.item_'+currentObject.id);
                  previewCalculation.push(currentObject.label);
                  break;
                case this.constants.CALCULATION_TYPE.CALCULATION:
                  calculation.push(currentObject.label);
                  previewCalculation.push(currentObject.label);
                  break;
                case this.constants.CALCULATION_TYPE.VALUE:
                  calculation.push(currentObject.label);
                  previewCalculation.push(currentObject.label);
                  break;
              }
            }
            let calculationString = calculation.join(' ');
            calculationString = calculationString.replace(/x/gi, '*').replace(/:/g, '/')
            let result = ''
            try {
              result = eval(calculationString);
              if (calculationFields[i].rounding_type == this.constants.CALCULATION_ROUND.DOWN){
                if (parseInt(calculationFields[i].number_decimal) > 0 || calculationFields[i].number_decimal === 0){
                  result = Math.floor(result * Math.pow(10, calculationFields[i].number_decimal)) / Math.pow(10, calculationFields[i].number_decimal);
                }
              }
              if (calculationFields[i].rounding_type == this.constants.CALCULATION_ROUND.UP){
                if (parseInt(calculationFields[i].number_decimal) > 0 || calculationFields[i].number_decimal === 0){
                  result = Math.ceil(result * Math.pow(10, calculationFields[i].number_decimal)) / Math.pow(10, calculationFields[i].number_decimal);
                }
              }
            } catch (error) {
              console.log(error)
            }
            if (isNaN(result)){
              result = '';
            }
            calculationFields[i].value = result;
            calculationFields[i].previewCalculation = previewCalculation.join(' ');
          }
        }

        let that = this;
        let fieldMultipleBranching = listField.filter(function (i){
          if (!i.related_items_decode){
            return false
          }
          if (i.input_method == that.fieldType.SELECTION_MULTIPLE){
            return true;
          }
          return false;
        });
        if (fieldMultipleBranching.length > 0){
          for (let i = 0;i < fieldMultipleBranching.length;i++){
            let field = fieldMultipleBranching[i];
            let compare = false;
            let answerActionCode = Object.values(field.answer_action_decode);
            let choose = Object.values(field.value);
            let options = field.selections.split(',');
            let optionsValues = [];
            for (let i = 0;i < choose.length;i++){
              optionsValues.push(options[choose[i]]);
            }
            // for (let i = 0; i < answerActionCode.length;i++){
            //   if (optionsValues.includes(answerActionCode[i])){
            //     compare = true;
            //     break;
            //   }
            // }
            let related = Object.values(field.related_items_decode);
            // let fieldRelated = listField.filter(function (i){
            //   if (related.includes(i.item_id)){
            //     return true;
            //   }
            //   return false;
            // })
              for (let j = 0;j < listField.length;j++){
                  for (let t = 0; t < related.length; t++) {
                      if (related[t].includes(listField[j].item_id)){
                          let duplicate = answerActionCode[t].filter(item => optionsValues.includes(item));
                          if (listField[j].display_start == constants.DISPLAY_START.HIDE_TO_SHOW){
                              if (duplicate.length > 0){
                                  listField[j].display = true;
                              }else{
                                  listField[j].display = false;
                                  listField[j].value = '';
                              }
                          }
                          if (listField[j].display_start == constants.DISPLAY_START.SHOW_TO_HIDE){
                              if (duplicate.length > 0){
                                  listField[j].display = false;
                                  listField[j].value = '';
                              }else{
                                  listField[j].display = true;
                              }
                          }
                      }
                  }
              }

            // for (let j = 0;j < fieldRelated.length;j++){
            //   if (fieldRelated[j].display_start == constants.DISPLAY_START.HIDE_TO_SHOW){
            //     if (compare){
            //       fieldRelated[j].display = true;
            //     }else{
            //       fieldRelated[j].display = false;
            //       fieldRelated[j].value = '';
            //     }
            //   }
            //   if (fieldRelated[j].display_start == constants.DISPLAY_START.SHOW_TO_HIDE){
            //     if (compare){
            //       fieldRelated[j].display = false;
            //       fieldRelated[j].value = '';
            //     }else{
            //       fieldRelated[j].display = true;
            //     }
            //   }
            // }
          }
        }

        let fieldBranching = listField.filter(function (i){
          if (!i.related_items_decode){
            return false
          }
          if (i.input_method == that.fieldType.SELECTION){
            return true;
          }
          return false;
        });

        if (fieldBranching.length > 0){
          for (let i = 0;i < fieldBranching.length;i++){
            let field = fieldBranching[i];
            let related = Object.values(field.related_items_decode);
            let options = field.selections.split(',');
            let answerActionCode = Object.values(field.answer_action_decode);
            let textChoose = options[field.value];
            // let compare = true;
            // let fieldRelated = listField.filter(function (i){
            //   if (related.includes(i.item_id)){
            //     return true;
            //   }
            //   return false;
            // });
            // if (!answerActionCode.includes(textChoose)){
            //   compare = false;
            // }

              for (let j = 0;j < listField.length;j++){
                  for (let t = 0; t < related.length; t++) {
                      if (related[t].includes(listField[j].item_id)){
                          if (listField[j].display_start == constants.DISPLAY_START.HIDE_TO_SHOW){
                              if (answerActionCode[t].includes(textChoose)){
                                  listField[j].display = true;
                              }else{
                                  listField[j].display = false;
                                  listField[j].value = '';
                              }
                          }
                          if (listField[j].display_start == constants.DISPLAY_START.SHOW_TO_HIDE){
                              if (answerActionCode[t].includes(textChoose)){
                                  listField[j].display = false;
                                  listField[j].value = '';
                              }else{
                                  listField[j].display = true;
                              }
                          }
                      }
                  }
              }

            // for (let j = 0;j < fieldRelated.length;j++){
            //   if (fieldRelated[j].display_start == constants.DISPLAY_START.HIDE_TO_SHOW){
            //     if (compare){
            //       fieldRelated[j].display = true;
            //     }else{
            //       fieldRelated[j].display = false;
            //       fieldRelated[j].value = '';
            //     }
            //   }
            //   if (fieldRelated[j].display_start == constants.DISPLAY_START.SHOW_TO_HIDE){
            //     if (compare){
            //       fieldRelated[j].display = false;
            //       fieldRelated[j].value = '';
            //     }else{
            //       fieldRelated[j].display = true;
            //     }
            //   }
            // }
          }
        }

        for (let i = 0;i < val.length;i++){
          let groups = val[i].groups;
          for (let j = 0;j < groups.length;j++){
            let fields = groups[j].fields;
            let fieldShow = fields.filter(function (i){
              return i.display == true;
            })
            if (fieldShow.length > 0){
              groups[j].display_group = true;
            }else{
              groups[j].display_group = false;
            }
          }
        }
        for (let i = 0;i < val.length;i++){
          let groups = val[i].groups;
          let groupShow = groups.filter(function (i){
            return i.display_group == true;
          })
          if (groupShow.length > 0){
            val[i].display_group = true;
          }else{
            val[i].display_group = false;
          }
        }

      },
      deep: true
    },
  },
  async created() {
    if (this.hasPermissonCheck('answer_flg')){
        this.loading = true;
        await this.getAnswerDetail( {
            answer_id: this.queryParam.answer_id,
            form_id: this.queryParam.form_id
        }).then((response)=>{
            if(response){
                if(response.data.code === constants.STATUS_CODE.HTTP_BAD_REQUEST){
                    this.title = this.$t("HTTP_BAD_REQUEST");
                    this.$bvModal.show("error-update");
                    this.loading = false
                }
            }
        })
        this.loading = false;
        this.form_detail.push(this.answerDetail.info)
        this.item_groups=this.answerDetail
        this.value_before=this.answerDetail.value
        this.answer_id = this.queryParam.answer_id;
        this.formParent=this.answerDetail.form_parent
        this.total_form_child=this.answerDetail.total_form_child
        this.currentRole=this.answerDetail.current_role
        this.currentStep=this.answerDetail.currentStep
        
        if( this.answerDetail.user && this.answerDetail.user.reject_items ){
			    this.fields_reject = []
			    const fieldsReject = JSON.parse(this.answerDetail.user.reject_items)
			    fieldsReject.forEach(itemReject=>{
            const itemIdStr = itemReject.item_id.toString();
              if( this.fields_reject.findIndex(id => id.toString() === itemIdStr) < 0 ){
                this.fields_reject.push(itemIdStr) 
              }
            if( itemReject.column_keys){
              for (const [formIndex, groupFormBase] of this.item_groups.form.entries() ){
                for (const [groupIndex, groups] of groupFormBase.groups.entries() ){
                  for (const [fieldIndex, field] of groups.fields.entries() ){
                    if( field.item_id.toString() === itemReject.item_id.toString() && field.input_method === this.fieldType.TABLE ){
                      this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].columns_reject = itemReject.column_keys
                    }
                  }
                }
              }
            }
			    })
          this.disable_reject = this.answerDetail.user.answer_status===constants.STATUS_ANSWER.DENIAL.KEY
        }
    }else {
        this.not_permisson_popup = true
        this.form_detail=[]
    }

    // Convert HTML comment to text ngay khi created
    this.comment = this.convertHtmlToText(this.answerDetail.user.comment)
  },
  methods: {
    ...mapActions([GET_ANSWER_DETAIL,
        ANSWER_HANDLE_STATUS,
        CHECK_ANSWER_DATA_CONFLICT,
        GET_LIST_VERSION,
        BUILD_URL_DOWNLOAD_FILE,
        GET_ALL_ROLE,
        CHANGE_ROLE,
        CHANGE_TOGGLE_TABLE_STEP,
        UPLOAD_FILE_USER,
        BYTES_TO_SIZE,
        STORE_SOFT_DELETE,
        STORE_FOCE_DELETE,
        RESTORE,
        REMOVE_ERROR_CHANGE_ROLE,
        UPDATE_ANSWER_VALUE]),
    sortTable(sortProps) {
        if (sortProps.prop == 'step'){
            let newStepList = this.currentStep.currenApprovalList.sort(function(a, b) {
                if (sortProps.order=='descending'){
                     return   b.step - a.step;
                }else {
                     return   a.step- b.step;
                }
            });
            this.currentStep.currenApprovalList = newStepList
        }else if ([ 'approval_status','role_name','mail','comment'].indexOf(sortProps.prop) >= 0 ){
            let newStepList = this.currentStep.currenApprovalList.sort(function(a, b) {
            if (sortProps.order=='descending'){
                return a[sortProps.prop] === b[sortProps.prop] ? 0 : a[sortProps.prop] > b[sortProps.prop] ? -1 : 1;
            }else {
                return a[sortProps.prop] === b[sortProps.prop] ? 0 : a[sortProps.prop] < b[sortProps.prop] ? -1 : 1;
            }
            });
            this.currentStep.currenApprovalList = newStepList
        }else if (sortProps.prop == 'approval_datetime' ){
             let newStepList = this.currentStep.currenApprovalList.sort(function(a, b) {
                 if (sortProps.order=='descending'){
                     return   new Date(a.step)- new Date(b.step);

                  }else {
                      return   new Date(b.step) - new Date(a.step);
                  }
              });
              this.currentStep.currenApprovalList = newStepList
          }
      },
      handleProcess(key) {
          var answer_id = this.answerDetail.user.answer_id;
          switch (key) {
              case constants.HANDLE_PROCESS.CONFIRM.KEY:
                  this.title = this.$t("CONFIRM" , {answer_id: answer_id});
                  this.key = constants.HANDLE_PROCESS.CONFIRM.KEY;
                  break;
              case constants.HANDLE_PROCESS.REJECT.KEY:
                  this.title = this.$t("REJECT" , {answer_id: answer_id});
                  this.key = constants.HANDLE_PROCESS.REJECT.KEY;
                  break;
              case constants.HANDLE_PROCESS.SAVE.KEY:
                  this.title = this.$t("SAVE" , {answer_id: answer_id});
                  this.key = constants.HANDLE_PROCESS.SAVE.KEY;
                  break;
              case constants.HANDLE_PROCESS.CHANGE_OF_CHRAGE.KEY:
                  this.title = this.$t("CHANGE_ROLE" , {answer_id: answer_id});
                  this.key = constants.HANDLE_PROCESS.CHANGE_OF_CHRAGE.KEY;
                  break;
              case constants.HANDLE_PROCESS.UPDATE_VALUE.KEY:
                  this.title = this.$t("UPDATE_VALUE" , {answer_id: answer_id});
                  this.key = constants.HANDLE_PROCESS.UPDATE_VALUE.KEY;
                  break;
              default:
                  break;
          }
          this.$bvModal.show("confirm");
          this.disable_confirm = false;
      },
    closePopup(key) {
      switch(key){
        case 'errorUpdate':
          this.$bvModal.hide("error-update");
          break;
        case 'confirm':
          this.$bvModal.hide("confirm");
          break;
        case 'answer_file':
          this.$bvModal.hide("answer_file");
          break;
        case 'change-role':
          this.$bvModal.hide("change-role");
          break;
        case 'delete_form_answer':
          this.$bvModal.hide("delete_form_answer");
          break;
        case 'errorRequired':
          this.$bvModal.hide("error-required");
          break;
        case 'answerConflictProceed':
          this.$bvModal.hide("answer-conflict-proceed");
          break;
        default:
          break;
      }

    },
    normalizeValidationErrors(errorPayload) {
      if (!errorPayload || !Array.isArray(errorPayload.errors)) {
        return {};
      }
      const mappedErrors = {};
      errorPayload.errors.forEach((item) => {
        if (!item) return;
        const message = item.message || "エラーが発生しました。";

        if (item.type === "field" || item.type === "file") {
          const resolvedFieldId = this.resolveFieldIdForError(item.field_id);
          const key = `field_${resolvedFieldId}`;
          mappedErrors[key] = mappedErrors[key] || [];
          mappedErrors[key].push(message);
          return;
        }

        if (item.type === "child_field") {
          const childKey = `field_child_${item.field_id}_value_${item.index || 0}`;
          mappedErrors[childKey] = mappedErrors[childKey] || [];
          mappedErrors[childKey].push(message);
          return;
        }

        if (item.type === "table_cell") {
          const resolvedFieldId = this.resolveFieldIdForError(item.field_id);
          const tableKey = `field_${String(resolvedFieldId)}`;
          if (!Array.isArray(mappedErrors[tableKey])) {
            mappedErrors[tableKey] = [{}];
          }
          if (!mappedErrors[tableKey][0]) {
            mappedErrors[tableKey][0] = {};
          }
          mappedErrors[tableKey][0][item.y_field_key] =
            mappedErrors[tableKey][0][item.y_field_key] || {};
          mappedErrors[tableKey][0][item.y_field_key][item.x_field_key] = {
            message,
          };
        }
      });
      return mappedErrors;
    },
    /**
     * Resolve API `field_id` to the actual `field.item_id` used by current rendered form.
     * This keeps duplicated block ids (e.g. `group_..._item_id_13464`) intact and only
     * falls back to numeric suffix when that exact id does not exist on screen.
     *
     * @param {string|number} rawFieldId
     * @returns {string}
     */
    resolveFieldIdForError(rawFieldId) {
      const raw = String(rawFieldId);
      const existsInCurrentForm = (id) => {
        const candidate = String(id);
        if (!this.item_groups || !Array.isArray(this.item_groups.form)) {
          return false;
        }
        for (const groupFormBase of this.item_groups.form) {
          for (const groups of groupFormBase.groups || []) {
            for (const field of groups.fields || []) {
              if (String(field.item_id) === candidate) {
                return true;
              }
            }
          }
        }
        return false;
      };

      if (existsInCurrentForm(raw)) {
        return raw;
      }

      const suffixMatch = raw.match(/item_id_(\d+)$/);
      if (suffixMatch && existsInCurrentForm(suffixMatch[1])) {
        return suffixMatch[1];
      }

      return raw;
    },
    isTableFieldErrorsStructure(val) {
      if (!Array.isArray(val) || val.length === 0) {
        return false;
      }
      const first = val[0];
      return (
        first &&
        typeof first === "object" &&
        !Array.isArray(first) &&
        typeof first !== "string"
      );
    },
    mergeValidationMappedIntoState(mapped) {
      if (!mapped || typeof mapped !== "object") return;
      Object.keys(mapped).forEach((key) => {
        const val = mapped[key];
        if (val === undefined || val === null) return;
        if (this.isTableFieldErrorsStructure(val)) {
          this.$set(this.errors, key, val);
        } else {
          this.$set(this.errorField, key, val);
        }
      });
    },
    async proceedHandleCheck(key, answer_id, email, answerValue) {
      this.disable_confirm = true;
      try {
        switch (key) {
          case constants.HANDLE_PROCESS.CONFIRM.KEY: {
            const response = await this.answerHandleStatus({
              answer_id: answer_id,
              email: email,
              status: constants.HANDLE_PROCESS.CONFIRM.KEY,
              comment: this.comment,
              answer_value: answerValue,
              form_value: this.item_groups.form,
              send_child_tenant_login_mail: this.answerDetail.user
                ? this.answerDetail.user.send_child_tenant_login_mail
                : 0,
            });
            this.handleRepsonse(response);
            break;
          }
          case constants.HANDLE_PROCESS.REJECT.KEY: {
            const rejectItems = [];
            const rejectItemTables = [];
            Object.keys(this.tables_reject).forEach((item_id) => {
              rejectItems.push({
                item_id: item_id,
                column_keys: this.tables_reject[item_id],
              });
              rejectItemTables.push(item_id.toString());
            });

            this.fields_reject.forEach((item_id) => {
              const itemIdStr = item_id.toString();
              if (rejectItemTables.indexOf(itemIdStr) < 0) {
                rejectItems.push({ item_id: item_id });
              }
            });

            const response = await this.answerHandleStatus({
              answer_id: answer_id,
              email: email,
              status: constants.HANDLE_PROCESS.REJECT.KEY,
              comment: this.comment,
              answer_value: answerValue,
              form_value: this.item_groups.form,
              reject_items: rejectItems,
            });
            this.handleRepsonse(response);
            break;
          }
          case constants.HANDLE_PROCESS.SAVE.KEY: {
            const response = await this.answerHandleStatus({
              answer_id: answer_id,
              email: email,
              status: constants.HANDLE_PROCESS.SAVE.KEY,
              comment: this.comment,
              answer_value: answerValue,
              form_value: this.item_groups.form,
            });
            this.handleRepsonse(response);
            break;
          }
          case constants.HANDLE_PROCESS.CHANGE_OF_CHRAGE.KEY: {
            const response = await this.changeRole({
              answer_id: answer_id,
              email: email,
              status: constants.HANDLE_PROCESS.CHANGE_OF_CHRAGE.KEY,
              comment: this.comment,
              role: this.change_role,
              answer_value: answerValue,
              form_value: this.item_groups.form,
            });
            if (response.data.code == constants.STATUS_CODE.SUCCESS) {
              await this.getAnswerDetail({
                answer_id: this.queryParam.answer_id,
                form_id: this.queryParam.form_id,
              });
              this.currentStep = this.answerDetail.currentStep;
              this.notifySuccess(this.$t("UPDATE_SUCCESS"));
              this.closePopup("change-role");
            } else if (response.data.code == constants.STATUS_CODE.PERMISSION) {
              this.closePopup("change-role");
              this.title = response.data.message;
              this.loading = false;
              this.$bvModal.show("error-update");
            }
            break;
          }
          case constants.HANDLE_PROCESS.UPDATE_VALUE.KEY: {
            const response = await this.updateAnswerValue({
              answer_id: answer_id,
              answer_value: answerValue,
              comment: this.comment,
              type: "update_value",
              form_value: this.item_groups.form,
            });
            this.handleRepsonse(response);
            break;
          }
          default:
            break;
        }
      } catch (e) {
        this.notifyError(e);
      } finally {
        this.disable_confirm = false;
      }
    },
    /**
     * User chose to continue registration despite the conflict warning (modal “続けて登録する”).
     * Builds the latest answer payload from the current form, then runs the same submit path as a
     * successful conflict check (`proceedHandleCheck`) so the server receives up-to-date values.
     *
     * @returns {Promise<void>}
     */
    async answerConflictProceedYes() {
      this.disable_conflict_proceed = true;
      this.$bvModal.hide("answer-conflict-proceed");
      const key = this.pendingConflictKey;
      const answer_id = this.pendingConflictAnswerId;
      const email = this.pendingConflictEmail;
      this.pendingConflictKey = null;
      this.pendingConflictAnswerValue = null;
      this.pendingConflictAnswerId = null;
      this.pendingConflictEmail = null;
      this.pendingConflictErrors = [];
      try {
        if (key != null && answer_id != null) {
          const answerValue = this.buildAnswerValueFromForm();
          await this.proceedHandleCheck(key, answer_id, email, answerValue);
        }
      } finally {
        this.disable_conflict_proceed = false;
      }
    },
    /**
     * User chose to review errors (modal “エラーを確認する”). Does not call the conflict API again.
     * Applies validation errors from the last `checkAnswerDataConflict` response (stored in
     * `pendingConflictErrors`) onto field/table error state so the UI highlights problem inputs.
     *
     * @returns {void}
     */
    answerConflictProceedNo() {
      this.$bvModal.hide("answer-conflict-proceed");
      const errList = this.pendingConflictErrors || [];
      this.pendingConflictKey = null;
      this.pendingConflictAnswerValue = null;
      this.pendingConflictAnswerId = null;
      this.pendingConflictEmail = null;
      this.pendingConflictErrors = [];
      if (errList.length > 0) {
        const mapped = this.normalizeValidationErrors({ errors: errList });
        this.mergeValidationMappedIntoState(mapped);
      }
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    /**
     * Serializes `item_groups.form` into the `answer_value` shape expected by submit / conflict APIs:
     * `field_{item_id}`, `field_child_{item_id}` objects, datetime normalization, and `key_value` on fields.
     *
     * @returns {Object<string, *>} Plain object of field keys to values (and child maps where applicable).
     */
    buildAnswerValueFromForm() {
      const answerValue = {};
      for (const groupFormBase of this.item_groups.form) {
        for (const groups of groupFormBase.groups) {
          for (const fields of groups.fields) {
            let valueFiled = fields.value;
            if (fields.input_method == this.fieldType.DATETIME) {
              valueFiled = this.convertDateTime(valueFiled);
            }
            fields.key_value = "field_" + fields.item_id;
            answerValue["field_" + fields.item_id] = valueFiled;
            if (fields.childFields.length > 0) {
              const valueChild = {};
              for (let i = 0; i < fields.childFields.length; i++) {
                let valueChildFiled = fields.childFields[i].value;
                if (
                  fields.childFields[i].input_method == this.fieldType.DATETIME
                ) {
                  valueChildFiled = this.convertDateTime(valueChildFiled);
                }
                valueChild["value_" + i] = valueChildFiled;
              }
              answerValue["field_child_" + fields.item_id] = valueChild;
            }
          }
        }
      }
      return answerValue;
    },
    /**
     * Interprets the `checkAnswerDataConflict` HTTP response and drives UI + next step.
     * If the API reports `reload_page`, `show_popup`, or inline `errors`, handles modals and merges
     * validation into state. If the response is “clean” (success, no popup/reload/errors), delegates
     * to `proceedHandleCheck` to run confirm / save / reject / etc. using the provided `key`.
     *
     * @param {import('axios').AxiosResponse|{ data?: * }} conflictRes - Axios response (or wrapper) whose `data` matches the API envelope.
     * @param {string} key - Action key from `constants.HANDLE_PROCESS` (e.g. confirm, save).
     * @param {number|string} answer_id - Current answer id.
     * @param {string} email - Respondent identifier (`unique_key_value`) for status APIs.
     * @param {Object<string, *>} answerValue - Serialized form payload from `buildAnswerValueFromForm`.
     * @returns {Promise<void>}
     */
    async processConflictCheckResponse(
      conflictRes,
      key,
      answer_id,
      email,
      answerValue
    ) {
      const body = conflictRes.data || {};
      const inner = body.data !== undefined ? body.data : body;
      const errList = Array.isArray(inner.errors) ? inner.errors : [];
      const showPopup = !!inner.show_popup;
      const reloadPage = !!inner.reload_page;
      const code = body.code;
      const codeOk = code === constants.STATUS_CODE.SUCCESS;
      const canProceed =
        codeOk && !showPopup && !reloadPage && errList.length === 0;

      if (!canProceed) {
        this.$bvModal.hide("confirm");
        this.$bvModal.hide("change-role");

        if (reloadPage) {
          this.title =
            "途中保存後にフォームが更新されたため実行できません。フォームを再読み込みしてください";
          if (errList.length > 0) {
            const mapped = this.normalizeValidationErrors({ errors: errList });
            this.mergeValidationMappedIntoState(mapped);
          }
          this.$bvModal.show("error-update");
          this.disable_confirm = false;
          this.$forceUpdate();
          return;
        }

        if (showPopup) {
          this.pendingConflictKey = key;
          this.pendingConflictAnswerValue = answerValue;
          this.pendingConflictAnswerId = answer_id;
          this.pendingConflictEmail = email;
          this.pendingConflictErrors = errList.slice();
          this.$bvModal.show("answer-conflict-proceed");
          this.disable_confirm = false;
          return;
        }

        if (errList.length > 0) {
          const mapped = this.normalizeValidationErrors({ errors: errList });
          this.mergeValidationMappedIntoState(mapped);
        }
        this.disable_confirm = false;
        this.$forceUpdate();
        return;
      }

      await this.proceedHandleCheck(key, answer_id, email, answerValue);
    },
    /**
     * Pre-submit gate: validates table rules, then calls `checkAnswerDataConflict` with the current
     * form. On success with no blocking flags, continues to `proceedHandleCheck`; otherwise shows
     * reload / conflict modal / inline errors via `processConflictCheckResponse`.
     *
     * @param {string} key - Which operation to run after a clean conflict check (see `constants.HANDLE_PROCESS`).
     * @returns {Promise<void>}
     */
    async handleCheck(key) {
      this.disable_confirm = true;
      var answer_id = this.answerDetail.user.answer_id;
      var email = this.answerDetail.user.unique_key_value;
      this.errorField = {};
      this.errors = [];

      if (!this.validateTableXColumnValue()) {
        this.disable_confirm = false;
        this.$bvModal.hide("confirm");
        this.$bvModal.show("error-required");
        return;
      }
      const answerValue = this.buildAnswerValueFromForm();

      let conflictRes;
      try {
        conflictRes = await this.checkAnswerDataConflict({
          answer_id: answer_id,
          form_value: this.item_groups.form,
        });
      } catch (e) {
        this.notifyError(e);
        this.disable_confirm = false;
        return;
      }

      await this.processConflictCheckResponse(
        conflictRes,
        key,
        answer_id,
        email,
        answerValue
      );
    },
    handleRepsonse(response) {
      if (response.data.code == constants.STATUS_CODE.SUCCESS) {
        this.notifySuccess(this.$t("UPDATE_SUCCESS"));
        this.closePopup('confirm');
        let self = this;
        setTimeout(function () {
          self.$router.push({
            name: "form-answer-list",
          });
        }, 500);
      } else if (response.data.code == constants.STATUS_CODE.BAD_REQUEST) {
          this.errorField = response.data.data;
          this.errors = response.data.data;
          if( response.data.data.reject_items  ){
            this.modal_error_msg = response.data.data.reject_items[0]
            this.$bvModal.show("error-reject")
          } else {
            this.$bvModal.show("error-required")
          }
          this.$bvModal.hide("confirm")
          
      } else {
        this.title = response.data.message;
        this.$bvModal.show("error-update");
        this.$bvModal.hide("confirm");
        this.loading = false
      }
    },
  updateVersion(file_id,item_id,label_name){
    this.label_name = label_name
    this.getListVersion({
      answer_id: this.queryParam.answer_id ,
      item_id: item_id,
      form_id: this.queryParam.form_id,
    })
    .then((response)=>{
        if(response.data.code == constants.STATUS_CODE.SUCCESS){
          this.sendListVersion(response)
        }
    });
  },
  sendListVersion(response){
    this.listVersion = response.data.data
    this.$bvModal.show("answer_file");
  },
  showItem(index) {
        this.toggleStatus[index] = !this.toggleStatus[index]
      },
  async openPopupChangeRole(){
    this.change_role = '';
    this.loading = true;
    await this.getAllRole({
        form_id: this.queryParam.form_id
    });
    this.removeErrorChangeRole();
    this.loading = false;
    this.$bvModal.show("change-role");
  },
      openPopupDetele( isSoftDetele) {
        this.checkMethodDetele = isSoftDetele;
        this.$bvModal.show("delete_form_answer");
      },
      showLableRequired(field){
          if (field.item_check_relation) {
              let arrCheck = [];
              field.item_check_relation.map(formItemDetail => {
                  arrCheck.push(formItemDetail.check_method);
              })
              if (arrCheck.includes(1)) {
                  return true
              }
          }
          return false
      },
      checkInputStatus(field){
          if (field.special_processing == constants.CHECK_TYPE_INPUT.EMAIL) {
              return false
          }
          if (field.item_role === constants.ITEM_ROLE_KEY.USER_ADMIN || field.item_role === constants.ITEM_ROLE_KEY.ADMIN || field.special_processing == 4) {
              return false;
          } else {
              return true;
          }
      },
      async uploadFile(e,field){
        this.loading = true;
          let key = 'field_'+field.item_id;
          if (e.target.files.length){
              let size = await this.bytesToSize(e.target.files[0].size);
              // if (size <= 350){
                  var files = e.target.files || e.dataTransfer.files;
                  const dataPush = new FormData()
                  dataPush.append("form_id", field.form_id);
                  dataPush.append("file", files[0]);
                  dataPush.append("item_id", field.item_id);
                  dataPush.append("answer_id", this.queryParam.answer_id);
                  const update = await this.uploadFileUser(dataPush);
                  this.loading = false;
                  if (update.code == constants.STATUS_CODE.BAD_REQUEST){
                      let obj = {[key]:update.data.file}
                      this.errorField = {...obj};
                  }else{
                      this.value_before[field.item_id] = update.data;
                      field.value = update.data;
                      if (Object.prototype.hasOwnProperty.call(field, 'field_value')) {
                        field.field_value = update.data;
                      }
                  }
              // }else{
              //     let obj = {[key]:"ファイルの容量が最大350MBでアップロードしてください。"}
              //     this.errorField = {...obj};
              // }
          }
          e.target.files = null;
          e.target.value = '';
          this.loading = false;
      },
      deteleFormAnswer() {
          if (this.checkMethodDetele == 1) {
              let respon = this.storeSoftDetele({answer_id: this.queryParam.answer_id})
                  .then((response) => {
                      this.notifySuccess('成功を削除')
                      this.getDetail()
                  }).catch(e => {
                      this.notifyError(e)
                  });
          } else if (this.checkMethodDetele == 2) {
              this.storeFoceDetele({answer_id: this.queryParam.answer_id})
                  .then((response) => {
                      this.notifySuccess('成功を削除')
                      setTimeout(()=>{
                          this.$router.push({name: "form-answer-list"})
                      }, 200);
                      return;
                  }).catch(e => {
                  this.notifyError(e)
              });
          } else if (this.checkMethodDetele == 3){
              this.restore({answer_id: this.queryParam.answer_id})
                  .then((response) => {
                  this.notifySuccess('元に戻しました。')
                  this.getDetail()
              }).catch(e => {
                  this.notifyError(e)
              });
          }

          this.closePopup('delete_form_answer')

      },
      getDetail() {
          this.getAnswerDetail({
              answer_id: this.queryParam.answer_id,
              form_id: this.queryParam.form_id
          }).then((response) => {
              if (response) {
                  if (response.data.code === constants.STATUS_CODE.HTTP_BAD_REQUEST) {
                      this.title = this.$t("HTTP_BAD_REQUEST");
                      this.$bvModal.show("error-update");
                      this.loading = false
                  }
              }
          })
      },
      getFileName($filePath){
          if ($filePath) {
              let explode = $filePath.split("/");
              return explode[explode.length - 1]
          }
          return '';
      },
      confirmUpdateValue(){
          this.title = this.$t("CHANGE_ROLE" , {answer_id: answer_id});
          this.key = constants.HANDLE_PROCESS.CHANGE_OF_CHRAGE.KEY;
          this.$bvModal.show("confirm");
      },
      convertDateTime(time){
          let timeFormat = '';
          if (time){
              let datetime = new Date(time);
              if (datetime){
                  let m = datetime.getMonth() + 1;
                  let d = datetime.getDate();
                  let y = datetime.getFullYear();
                  let hours = datetime.getHours();
                  let minutes = datetime.getMinutes();
                  let seconds = datetime.getSeconds();
                  timeFormat = y+'-'+m+'-'+d+' '+hours+':'+minutes+':'+seconds;
              }
          }
          return timeFormat;
      },

      fieldRejectChange(event){
        for (const [formIndex, groupFormBase] of this.item_groups.form.entries() ){
          for (const [groupIndex, groups] of groupFormBase.groups.entries() ){
            for (const [fieldIndex, field] of groups.fields.entries() ){
              if( field.item_id.toString() === event.target.value.toString() ){
                if( field.input_method === this.fieldType.TABLE ){
                  this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].reject_all = true
                }
              }
            }
          }
        }
      },

	  changeFieldsReject(item_id, is_reject, xColumnFieldKeys){
      const itemIdStr = item_id.toString();
      if( is_reject ){
        const existingIndex = this.fields_reject.findIndex(id => id.toString() === itemIdStr);
        if( existingIndex < 0 ){
            this.fields_reject.push(itemIdStr);
        }
      } else {
        const index = this.fields_reject.findIndex(id => id.toString() === itemIdStr);
        if( index > -1 ){
            this.fields_reject.splice(index, 1);
        }
      }

      // Update tables_reject
      if( xColumnFieldKeys ){
        // If array is empty [] → remove from tables_reject AND uncheck field
        if( Array.isArray(xColumnFieldKeys) && xColumnFieldKeys.length === 0 ){
          delete this.tables_reject[itemIdStr];
          // Ensure remove from fields_reject
          const index = this.fields_reject.findIndex(id => id.toString() === itemIdStr);
          if( index > -1 ){
            this.fields_reject.splice(index, 1);
          }
        } else {
          // There is column rejected → save to tables_reject
          this.tables_reject[itemIdStr] = xColumnFieldKeys;
        }
      } else {
        // xColumnFieldKeys = null/undefined → remove from tables_reject
        delete this.tables_reject[itemIdStr];
      }
      
    },
    
    // Handle table value change từ InputTablesView
    handleTableValueChange(tableData) {
      //find field in item_groups.form
      for (const [formIndex, groupFormBase] of this.item_groups.form.entries()) {
        for (const [groupIndex, groups] of groupFormBase.groups.entries()) {
          for (const [fieldIndex, field] of groups.fields.entries()) {
            if (field.item_id.toString() === tableData.field_key.toString()) {
              // update field value with data from table
              this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].value = JSON.stringify({
                values: tableData.values,
                x_items: tableData.x_items
              });
              
              // update value_before to track changes
              if (this.value_before) {
                this.value_before[field.item_id] = {
                  values: tableData.values,
                  x_items: tableData.x_items
                };
              }
              break;
            }
          }
        }
      }
    },
    
    /**
     * start file removal methods
     */
    confirmRemoveFile(field) {
      this.fileToRemove = { field, type: 'main' };
      this.$bvModal.show('confirmRemoveFileModal');
    },
    
    async removeFile() {
      try {
        const payload = {
          item_id: this.fileToRemove.field.item_id,
          file_id: this.fileToRemove.field.value.file_id,
          answer_id: this.queryParam.answer_id
        };
        const response = await this.$store.dispatch(FORM_ITEM_DELETE_UPLOAD_FILE_ANSWER_DETAIL, payload);
        if (response.code === constants.STATUS_CODE.SUCCESS) {
          this.fileToRemove.field.value = null;
          this.value_before[this.fileToRemove.field.item_id] = null;
          
          // Reset input file để có thể upload lại cùng file
          const fileInput = document.getElementById('file-upload' + this.fileToRemove.field.item_id);
          if (fileInput) {
            fileInput.files = null;
            fileInput.value = '';
          }
          
          this.$forceUpdate();
          this.$bvModal.hide('confirmRemoveFileModal');
          this.fileToRemove = null;
        }
      } catch (error) {
        console.log(error,'error')
      }
    },
    cancelRemoveFile() {
      this.fileToRemove = null;
      this.$bvModal.hide('confirmRemoveFileModal');
    },
    /**
     * end file removal methods
     */
    
    /**
     * Convert HTML to text
     */
    convertHtmlToText(htmlString) {
      if (!htmlString) return '';
      
      // Create temporary element to parse HTML and get text content
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      
      // Get text content and  handle 
      return tempDiv.textContent || tempDiv.innerText || '';
    },
    
    validateTableXColumnValue() {
      let isPass = true;
      this.errors = [];

      // Loop through all form groups to find table fields
      for (const groupFormBase of this.item_groups.form) {
        for (const groups of groupFormBase.groups) {
          for (const field of groups.fields) {
            if (parseInt(field.input_method, 10) === parseInt(this.fieldType.TABLE, 10)) {
              this.$set(this.errors, "field_" + field.item_id, []);
              
              // Check if field has value and x_items
              if (field.value) {
                let fieldValue;
                try {
                  // Parse JSON if it's a string
                  fieldValue = typeof field.value === 'string' ? JSON.parse(field.value) : field.value;
                } catch (e) {
                  fieldValue = field.value;
                }
                
                if (fieldValue && fieldValue.x_items && Array.isArray(fieldValue.x_items)) {
                  for (const xField of fieldValue.x_items) {
                    if (!xField.label_name || xField.label_name.trim() < 1) {
                      this.errors['field_' + field.item_id][xField.field_key] = "必須項目を入力してください。";
                      isPass = false;
                    }
                  }
                }
              }
            }
          }
        }
      }
      
      return isPass;
    },
    
    /**
     * Check if all fields in group are rejected
     */
    isGroupRejected(groupItem) {
      if (!groupItem.groups || groupItem.groups.length === 0) {
        return false;
      }
      
      // Get all item_id of fields that can be rejected in group
      const rejectableFieldIds = this.getRejectableFieldIds(groupItem);
      
      if (rejectableFieldIds.length === 0) {
        return false;
      }
      
      // Check if all fields that can be rejected are in fields_reject
      return rejectableFieldIds.every(fieldId => 
        this.fields_reject.findIndex(id => id.toString() === fieldId.toString()) > -1
      );
    },
    
    /**
     * Get list item_id of fields that can be rejected in group
     */
    getRejectableFieldIds(groupItem) {
      const fieldIds = [];
      
      if (!groupItem.groups) {
        return fieldIds;
      }
      
      for (const group of groupItem.groups) {
        if (!group.fields) continue;
        
        for (const field of group.fields) {
          // Only get fields that can be rejected
          if (field.item_id 
              && [this.type_input.PASSWORD, this.type_input.EMAIL].indexOf(field.special_processing) < 0
              && [this.fieldType.LABEL, this.fieldType.CALCULATION, this.fieldType.FILE_DOWNLOAD].indexOf(field.input_method) < 0 
              && field.item_role !== 3) {
            fieldIds.push(field.item_id);
          }
        }
      }
      
      return fieldIds;
    },
    
    /**
     * Handle when change checkbox reject of group
     */
    handleGroupRejectChange(event, groupItem) {
      const isChecked = event.target.checked;
      const rejectableFieldIds = this.getRejectableFieldIds(groupItem);
      
      if (isChecked) {
        // Tick checkbox group: add all fields to fields_reject
        rejectableFieldIds.forEach(fieldId => {
          const fieldIdStr = fieldId.toString();
          if (this.fields_reject.findIndex(id => id.toString() === fieldIdStr) < 0) {
            this.fields_reject.push(fieldIdStr);
          }
        });
        
        // For fields with input_method is TABLE, need to set reject_all = true
        for (const [formIndex, groupFormBase] of this.item_groups.form.entries()) {
          for (const [groupIndex, groups] of groupFormBase.groups.entries()) {
            for (const [fieldIndex, field] of groups.fields.entries()) {
              if (rejectableFieldIds.findIndex(id => id.toString() === field.item_id.toString()) > -1 && field.input_method === this.fieldType.TABLE) {
                this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].reject_all = true;
              }
            }
          }
        }
      } else {
        // Untick checkbox group: remove all fields from fields_reject
        rejectableFieldIds.forEach(fieldId => {
          this.fields_reject = this.fields_reject.filter(id => 
            id.toString() !== fieldId.toString()
          );
          
          // Remove from tables_reject if exists
          if (this.tables_reject[fieldId]) {
            delete this.tables_reject[fieldId];
          }
          if (this.tables_reject[fieldId.toString()]) {
            delete this.tables_reject[fieldId.toString()];
          }
        });
        
        // For fields with input_method is TABLE, need to set reject_all = false
        for (const [formIndex, groupFormBase] of this.item_groups.form.entries()) {
          for (const [groupIndex, groups] of groupFormBase.groups.entries()) {
            for (const [fieldIndex, field] of groups.fields.entries()) {
              if (rejectableFieldIds.findIndex(id => id.toString() === field.item_id.toString()) > -1 && field.input_method === this.fieldType.TABLE) {
                this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].reject_all = false;
                this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].columns_reject = [];
              }
            }
          }
        }
      }
    },
    
    /**
     * Check all fields in child group are rejected
     */
    isChildGroupRejected(childGroup) {
      if (!childGroup.fields || childGroup.fields.length === 0) {
        return false;
      }
      
      // Get all item_id of fields that can be rejected in child group
      const rejectableFieldIds = this.getRejectableFieldIdsFromFields(childGroup.fields);
      
      if (rejectableFieldIds.length === 0) {
        return false;
      }
      // Check if all fields that can be rejected are in fields_reject
      return rejectableFieldIds.every(fieldId => 
        this.fields_reject.findIndex(id => id.toString() === fieldId.toString()) > -1
      );
    },
    
    /**
     * Get list item_id of fields that can be rejected from array fields
     */
    getRejectableFieldIdsFromFields(fields) {
      const fieldIds = [];
      
      if (!fields) {
        return fieldIds;
      }
      
      for (const field of fields) {
        // Only get fields that can be rejected
        if (field.item_id 
            && [this.type_input.PASSWORD, this.type_input.EMAIL].indexOf(field.special_processing) < 0
            && [this.fieldType.LABEL, this.fieldType.CALCULATION, this.fieldType.FILE_DOWNLOAD].indexOf(field.input_method) < 0 
            && field.item_role !== 3) {
          fieldIds.push(field.item_id);
        }
      }
      
      return fieldIds;
    },
    
    /**
     * Handle when change checkbox reject of child group
     */
    handleChildGroupRejectChange(event, childGroup) {
      const isChecked = event.target.checked;
      const rejectableFieldIds = this.getRejectableFieldIdsFromFields(childGroup.fields);
      
      if (isChecked) {
        // Tick checkbox child group: add all fields to fields_reject
        rejectableFieldIds.forEach(fieldId => {
          const fieldIdStr = fieldId.toString();
          if (this.fields_reject.findIndex(id => id.toString() === fieldIdStr) < 0) {
            this.fields_reject.push(fieldIdStr);
          }
        });
        
        // For fields with input_method is TABLE, need to set reject_all = true
        for (const [formIndex, groupFormBase] of this.item_groups.form.entries()) {
          for (const [groupIndex, groups] of groupFormBase.groups.entries()) {
            for (const [fieldIndex, field] of groups.fields.entries()) {
              if (rejectableFieldIds.findIndex(id => id.toString() === field.item_id.toString()) > -1 && field.input_method === this.fieldType.TABLE) {
                this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].reject_all = true;
              }
            }
          }
        }
      } else {
        // Untick checkbox child group: remove all fields from fields_reject
        rejectableFieldIds.forEach(fieldId => {
          this.fields_reject = this.fields_reject.filter(id => 
            id.toString() !== fieldId.toString()
          );
          if (this.tables_reject[fieldId]) {
            delete this.tables_reject[fieldId];
          }
          if (this.tables_reject[fieldId.toString()]) {
            delete this.tables_reject[fieldId.toString()];
          }
        });
        
        // For fields with input_method is TABLE, need to set reject_all = false
        for (const [formIndex, groupFormBase] of this.item_groups.form.entries()) {
          for (const [groupIndex, groups] of groupFormBase.groups.entries()) {
            for (const [fieldIndex, field] of groups.fields.entries()) {
              if (rejectableFieldIds.findIndex(id => id.toString() === field.item_id.toString()) > -1  && field.input_method === this.fieldType.TABLE) {
                this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].reject_all = false;
                this.item_groups.form[formIndex].groups[groupIndex].fields[fieldIndex].columns_reject = [];
              }
            }
          }
        }
      }
    },
   
    // Check if user can access tenant
    canAccessTenant(item) {
      if (!this.currentUser.role || !item) {
        return false;
      }
      // Check if tenant_code matches
      const isSameTenant = item.tenant_code === this.currentUser.role.tenant_code;
      
      return isSameTenant;
    },
    
    // Handle breadcrumb click
    handleBreadcrumbClick(item) {
      if (!item) return;
      if(this.currentUser.role && this.currentUser.role.tenant_code === null){
        window.open(item.admin_url, '_blank')
        return;
      }
      if(item.tenant_status === 2){
        // Redirect to 404 page
        this.$router.push({ name: '404' })
        return;
      }
      // Check if user can access
      if ((this.canAccessTenant(item) && this.currentUser.role.kengen_flg === 1) || (this.canAccessTenant(item) && this.currentUser.role.tennant_flg === 1) || (this.currentUser.role.kengen_flg === 1 && this.currentUser.role.tennant_flg === 1 && this.canAccessTenant(item))) {
        // Redirect to admin login page
        window.open(item.admin_url, '_blank')
      } else {
        // Show permission error popup
        this.breadcrumbPermissionError = true;
      }
    }
  },
};
</script>

<style scoped lang="scss">
.header-modal{
    padding-bottom: 30px;
    padding-top: 10px;
}
@media only screen and (max-width: 640px) and (min-width: 320px) {
  .btn-submit {
    padding: 4px 0px;
    background: #009ef7;
    top: 50px;
    width: 93px;
    height: 30px;
    border-radius: 5px;
    margin: 10px;
  }
  .textarea-form.value.el-col.el-col-18 {
    width: 100%;
  }
  .value.el-col.el-col-8 {
    right: 0px;
    margin-top: 10px;
    width: 100%;
  }
  h3.card-label {
    margin-top: 40px;
    font-size: 18px;
    font-weight: 700;
    width: max-content;
}
a.view-version {
    float: left;
    width: 100%;
     margin-left:0px !important;
}
.item-answer.el-row {
    display: block !important;
    padding-bottom:20px !important;

}
.label_name.el-col.el-col-5 {
    width: 100%;
    margin-top: 20px;

}
.angle-down , .angle-up{
  margin-top: 44px;
}
}
// end mobie
.text-center.button-update-status.el-row {
    display: block;
    margin-top: 30px;
}
.textarea {
  background: #f5f8fa;
}
.el-row {
  &:last-child {
    margin-bottom: 40px;
  }
  .view-version {
    margin-left:40px
  }
}
.btn-submit {
  padding: 4px 0px;
  background: #009ef7;
  top: 50px;
  width: 93px;
  height: 30px;
  font-size: 16px;
  border-radius: 5px;
}
.el-col {
  margin-top: 40px;
  border-radius: 4px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.disable-buttoon {
    background-color: grey !important;
    border: none;
}

.el-col {
  &.label_name {
    font-family: "Poppins";
    font-style: normal;
    font-weight: normal;
    line-height: 21px;
    font-weight: 500!important;
    font-size: 14px;
    color: #606266;
     margin-top: 10px;
    /* identical to box height */
  }
  &.value {
    font-family: "Poppins";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
     margin-top: 0;
    /* identical to box height */
    color: #000000;
  }
  .button-update-status{
    margin-top: 20px;
  }
  .item-answer.el-row {
      display: block !important;
      padding-bottom:20px !important;
  }
}
i.fas.fa-angle-down.pr-2.text-size-27 ,h3.card-label {
    cursor: pointer !important;
}
.button-upload-file{
  float: left;
  margin-right: 10px;
}
.item-answer .label_name{
  padding-right: 15px;
}

.modal .modal-header{
  display: block;
  text-align: center;
  padding: 13px;
}
.modal .modal-header .close{
  position: absolute;
  top: 24px;
  right: 15px;
}
.group-form{
    position: relative;
}
.modal-content{
    border-radius: 15px;
    border: 2px solid #000000;
}
.box-file {
    min-height: 38px;
}
.box-file >div {
    width: 400px;
}

.field-input-item {
  position: relative;
  padding-right: 20px;
  .field-reject {
    display: block;
    position: absolute;
    right: -5px;
    top: 13px;
    input[type=checkbox]
    {
      /* Double-sized Checkboxes */
      -ms-transform: scale(2); /* IE */
      -moz-transform: scale(2); /* FF */
      -webkit-transform: scale(2); /* Safari and Chrome */
      -o-transform: scale(2); /* Opera */
      transform: scale(2);
      padding: 10px;
    }
  }
}

.cursor-pointer {
  cursor: pointer;
}

.el-icon-circle-close {
  cursor: pointer;
  color: #000;
}
.el-icon-circle-close:hover {
  color: red;
}

.group-reject-checkbox {
  display: flex;
  align-items: center;
  
  input[type=checkbox] {
    /* Double-sized Checkboxes */
    -ms-transform: scale(1.5);
    -moz-transform: scale(1.5);
    -webkit-transform: scale(1.5);
    -o-transform: scale(1.5);
    transform: scale(1.5);
    cursor: pointer;
  }
  
  label {
    margin-bottom: 0;
    cursor: pointer;
    font-size: 14px;
    color: #606266;
    font-weight: 500;
  }
}

.title-group-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 20px;
}

.child-group-reject-checkbox {
  display: flex;
  align-items: center;
  
  input[type=checkbox] {
    /* Medium-sized Checkboxes for child groups */
    -ms-transform: scale(1.3);
    -moz-transform: scale(1.3);
    -webkit-transform: scale(1.3);
    -o-transform: scale(1.3);
    transform: scale(1.3);
    cursor: pointer;
  }
  
  label {
    margin-bottom: 0;
    cursor: pointer;
    font-size: 13px;
    color: #606266;
    font-weight: 400;
    }
  }
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  list-style: none;
  background-color: transparent;
  border-radius: 6px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #7e8299;
  
  + .breadcrumb-item {
    padding-left: 8px;
    
    &::before {
      display: inline-block;
      padding: 0 8px;
      content: ">";
      color: #b5b5c3;
      font-weight: 600;
    }
  }
  
  &.active {
    color: #181c32;
    font-weight: 500;
  }
}

.breadcrumb-link {
  color: #009ef7;
  transition: color 0.2s ease;
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px; 
  }
}
</style>

<style lang="scss">
.form-item {
    &.date-picker {
        .el-input__prefix {
            margin-left: 20px;
        }
    }
    &.item-upload {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 5px;
        
        .file-upload-info {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .file-upload-btn {
            margin-right: 5px;
        }
        .show-history-upload,
        .file-anchor {
            text-decoration: none;
            line-height: 38px;
        }
    }
}
</style>
